import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/tableA2-2.png';
import _imports_1 from '../../assets/tableA2-1.png';
const _hoisted_1 = {
  style: {
    "height": "100%"
  }
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_3 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_4 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_5 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_7 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_8 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_10 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_11 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_12 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_13 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_14 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_15 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_17 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_18 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_19 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_20 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_21 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_22 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_23 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_24 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_25 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_26 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_27 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_28 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_29 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_30 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_31 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_32 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_33 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_34 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_35 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_36 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_37 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_38 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_39 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_40 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_41 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_42 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_43 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_44 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_45 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_46 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_47 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_48 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_49 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_50 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_51 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_52 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_53 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_54 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_55 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_56 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_57 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_58 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_59 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_60 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_61 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_62 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_63 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_64 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_65 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_66 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_67 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_68 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_69 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_70 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_71 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_72 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_73 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_74 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_75 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_76 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_77 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_78 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_79 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_80 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_81 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_82 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_83 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_84 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_85 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_86 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_87 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_88 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_89 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_90 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_91 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_92 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_93 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_94 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_95 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_96 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_97 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_98 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_99 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_100 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_101 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_102 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_103 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_104 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_105 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_106 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_107 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_108 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_109 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_110 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_111 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_112 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_113 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_114 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_115 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_116 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_117 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_118 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_119 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_120 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_121 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_122 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_123 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_124 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_125 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_126 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_127 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_128 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_129 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_130 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_131 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_132 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_133 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_134 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_135 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_136 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_137 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_138 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_139 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};
const _hoisted_140 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_141 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_142 = {
  style: {
    "font-weight": "bold",
    "margin-top": "10px"
  }
};
const _hoisted_143 = {
  style: {
    "magin": "10px auto",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_cache[311] || (_cache[311] = _createElementVNode("text", null, "注：本表所列项目无测量时，观测数据和测量结果可不填写，但结果判定应填写（“√”、“×”、“/”），对不适用项填“/”。", -1)), _createVNode(_component_el_form, {
    ref: "form",
    model: $data.formData
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions, {
      title: "序号: 1 项目编号: A2.2.2.1",
      style: {}
    }, {
      extra: _withCtx(() => [...(_cache[104] || (_cache[104] = []))]),
      _: 1
    }), _cache[285] || (_cache[285] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  "), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("(1)  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "测量在楼层板平面的梳齿与踏面相交线位置的照度是否至少为50lx")])], -1)), _createElementVNode("div", _hoisted_2, [_cache[107] || (_cache[107] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目:"), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "照度")], -1)), _cache[108] || (_cache[108] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "lx")], -1)), _createElementVNode("div", _hoisted_3, [_cache[105] || (_cache[105] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data1,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formData.data1 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_cache[106] || (_cache[106] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result1,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formData.result1 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_5, [_cache[109] || (_cache[109] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine1,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formData.determine1 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 2 项目编号: A2.2.2.2",
      style: {}
    }), _cache[286] || (_cache[286] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row",
        "margin-top": "10px"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "检查出入口区域是否充分畅通，其宽度至少等于扶手带外缘距离加上每边各80mm，纵深尺寸从扶手装置端部算起至少为2.50m；该区域的宽度不小于扶手带外缘之间距离的2倍加上每边各80mm时，其纵深尺寸允许减少至2.00m")])], -1)), _createElementVNode("div", _hoisted_6, [_cache[112] || (_cache[112] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "出入口区域宽度")], -1)), _cache[113] || (_cache[113] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_7, [_cache[110] || (_cache[110] = _createTextVNode(" 观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data2,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formData.data2 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_cache[111] || (_cache[111] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result2,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formData.result2 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_9, [_cache[116] || (_cache[116] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "出入口区域纵深尺寸")], -1)), _cache[117] || (_cache[117] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "m")], -1)), _createElementVNode("div", _hoisted_10, [_cache[114] || (_cache[114] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data3,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formData.data3 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_cache[115] || (_cache[115] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result3,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formData.result3 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_12, [_cache[118] || (_cache[118] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine2,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.formData.determine2 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 3 项目编号: A2.2.2.3",
      style: {}
    }), _cache[287] || (_cache[287] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "出入口防护装置至少高出扶手带100mm，位于扶手带外缘80mm～120mm处")])], -1)), _createElementVNode("div", _hoisted_13, [_cache[121] || (_cache[121] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "高出扶手带的距离")], -1)), _cache[122] || (_cache[122] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_14, [_cache[119] || (_cache[119] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data4,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.formData.data4 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_15, [_cache[120] || (_cache[120] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result4,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.formData.result4 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_16, [_cache[125] || (_cache[125] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "与扶手带外缘距离")], -1)), _cache[126] || (_cache[126] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_17, [_cache[123] || (_cache[123] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data5,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.formData.data5 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_18, [_cache[124] || (_cache[124] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result5,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.formData.result5 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _cache[288] || (_cache[288] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "出入口防护装置从楼层板起高度不小于1100mm")])], -1)), _createElementVNode("div", _hoisted_19, [_cache[129] || (_cache[129] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "从楼层板起的高度")], -1)), _cache[130] || (_cache[130] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_20, [_cache[127] || (_cache[127] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data6,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.formData.data6 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_21, [_cache[128] || (_cache[128] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result6,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.formData.result6 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_22, [_cache[131] || (_cache[131] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine3,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.formData.determine3 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 4 项目编号: A2.2.2.4",
      style: {}
    }), _cache[289] || (_cache[289] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "受检设备与楼板有交叉或者受检设备之间有交叉的，检查交叉处是否设有垂直固定、无锐利边缘的封闭防护挡板，其位于扶手带上方的防护高度不小于0.30m，并且延伸至扶手带下缘以下至少25mm。扶手带外缘与任何障碍物之间的距离不小于400mm的，可以不设置防护挡板")])], -1)), _createElementVNode("div", _hoisted_23, [_cache[134] || (_cache[134] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防护挡板高度")], -1)), _cache[135] || (_cache[135] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "m")], -1)), _createElementVNode("div", _hoisted_24, [_cache[132] || (_cache[132] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data7,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.formData.data7 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_25, [_cache[133] || (_cache[133] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result7,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.formData.result7 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_26, [_cache[138] || (_cache[138] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "扶手带下缘以下距离")], -1)), _cache[139] || (_cache[139] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_27, [_cache[136] || (_cache[136] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data8,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.formData.data8 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_28, [_cache[137] || (_cache[137] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result8,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.formData.result8 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_29, [_cache[140] || (_cache[140] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine4,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.formData.determine4 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 5 项目编号: A2.2.2.5",
      style: {}
    }), _cache[290] || (_cache[290] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "墙壁或者障碍物与扶手带外缘之间的水平距离不小于80mm，与扶手带下缘的垂直距离不小于25mm")])], -1)), _createElementVNode("div", _hoisted_30, [_cache[143] || (_cache[143] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "水平距离")], -1)), _cache[144] || (_cache[144] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_31, [_cache[141] || (_cache[141] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data9,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.formData.data9 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_32, [_cache[142] || (_cache[142] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result9,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.formData.result9 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_33, [_cache[147] || (_cache[147] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "垂直距离")], -1)), _cache[148] || (_cache[148] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_34, [_cache[145] || (_cache[145] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data10,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.formData.data10 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_35, [_cache[146] || (_cache[146] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result10,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.formData.result10 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_36, [_cache[149] || (_cache[149] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine5,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.formData.determine5 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _cache[291] || (_cache[291] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row",
        "margin-top": "10px"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "对于邻近布置的受检设备，其扶手带外缘之间的距离不小于160mm")])], -1)), _createElementVNode("div", _hoisted_37, [_cache[152] || (_cache[152] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "邻近扶手带外缘之间的距离")], -1)), _cache[153] || (_cache[153] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_38, [_cache[150] || (_cache[150] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data11,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.formData.data11 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_39, [_cache[151] || (_cache[151] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result11,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.formData.result11 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_40, [_cache[154] || (_cache[154] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine6,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.formData.determine6 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 6 项目编号: A2.2.2.6",
      style: {}
    }), _cache[292] || (_cache[292] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "多台连续并且无中间出口的受检设备，在梯级、踏板或胶带到达梳齿与踏面相交线之前2.00m～3.00m处，设有乘客易于触及的附加紧急停止开关")])], -1)), _createElementVNode("div", _hoisted_41, [_cache[157] || (_cache[157] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "附加紧急停止开关与踏面相交线的距离")], -1)), _cache[158] || (_cache[158] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "m")], -1)), _createElementVNode("div", _hoisted_42, [_cache[155] || (_cache[155] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data12,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.formData.data12 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_43, [_cache[156] || (_cache[156] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result12,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.formData.result12 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_44, [_cache[159] || (_cache[159] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine7,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.formData.determine7 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 7 项目编号: A2.2.2.8",
      style: {}
    }), _cache[293] || (_cache[293] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "梳齿板梳齿与踏面齿槽的啮合深度至少为4mm，梳齿槽根部与踏面的间隙不超过4mm")])], -1)), _createElementVNode("div", _hoisted_45, [_cache[162] || (_cache[162] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "啮合深度")], -1)), _cache[163] || (_cache[163] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_46, [_cache[160] || (_cache[160] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data13,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.formData.data13 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_47, [_cache[161] || (_cache[161] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result13,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $data.formData.result13 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_48, [_cache[166] || (_cache[166] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "间隙")], -1)), _cache[167] || (_cache[167] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_49, [_cache[164] || (_cache[164] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data14,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.formData.data14 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_50, [_cache[165] || (_cache[165] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result14,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.formData.result14 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_51, [_cache[168] || (_cache[168] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine8,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.formData.determine8 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 8 项目编号: A2.2.2.9",
      style: {}
    }), _cache[294] || (_cache[294] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "受检设备出入口附近设有紧急停止开关，必要时增设附加紧急停止开关，以使紧急停止开关之间的距离不超过30m(适用于自动扶梯)或者40m(适用于自动人行道)")])], -1)), _createElementVNode("div", _hoisted_52, [_cache[171] || (_cache[171] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "紧急停止开关之间的距离")], -1)), _cache[172] || (_cache[172] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "m")], -1)), _createElementVNode("div", _hoisted_53, [_cache[169] || (_cache[169] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data15,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.formData.data15 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_54, [_cache[170] || (_cache[170] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result15,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => $data.formData.result15 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_55, [_cache[173] || (_cache[173] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine9,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.formData.determine9 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _cache[295] || (_cache[295] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row",
        "margin-top": "10px"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "各紧急停止开关标识清晰，对于位于扶手装置高度1/2以下的紧急停止开关，在扶手装置高度1/2以上的醒目位置还设有直径至少为80mm的红底白字“急停”指示标记，箭头指向该开关")])], -1)), _createElementVNode("div", _hoisted_56, [_cache[176] || (_cache[176] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "指示标记直径")], -1)), _cache[177] || (_cache[177] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_57, [_cache[174] || (_cache[174] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data16,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => $data.formData.data16 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_58, [_cache[175] || (_cache[175] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result16,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.formData.result16 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_59, [_cache[178] || (_cache[178] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine10,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $data.formData.determine10 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 9 项目编号: A2.2.3.1",
      style: {}
    }), _cache[296] || (_cache[296] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "扶手带完好、表面无龟裂、剥离、严重磨损，扶手带单一开裂处最大裂纹宽度不大于3mm")])], -1)), _createElementVNode("div", _hoisted_60, [_cache[181] || (_cache[181] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "最大裂纹宽度")], -1)), _cache[182] || (_cache[182] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_61, [_cache[179] || (_cache[179] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data17,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => $data.formData.data17 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_62, [_cache[180] || (_cache[180] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result17,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $data.formData.result17 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_63, [_cache[183] || (_cache[183] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine11,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $data.formData.determine11 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _cache[297] || (_cache[297] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row",
        "margin-top": "10px"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "扶手转向端入口处的最低点与地板之间的垂直距离不小于0.10m，并且不大于0.25m")])], -1)), _createElementVNode("div", _hoisted_64, [_cache[186] || (_cache[186] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "垂直距离")], -1)), _cache[187] || (_cache[187] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "m")], -1)), _createElementVNode("div", _hoisted_65, [_cache[184] || (_cache[184] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data18,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => $data.formData.data18 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_66, [_cache[185] || (_cache[185] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result18,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => $data.formData.result18 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_67, [_cache[188] || (_cache[188] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine12,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $data.formData.determine12 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _cache[298] || (_cache[298] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row",
        "justify-content": "space-around"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (3)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "朝向梯级、踏板或者胶带一侧的部分光滑、平齐；装设方向与运行方向不一致的压条或者镶条凸出高度不大于3mm，其边缘呈圆角或者倒角状；沿运行方向的盖板连接处结构能够防止勾绊")])], -1)), _createElementVNode("div", _hoisted_68, [_cache[191] || (_cache[191] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "凸出高度")], -1)), _cache[192] || (_cache[192] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_69, [_cache[189] || (_cache[189] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data19,
      "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => $data.formData.data19 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_70, [_cache[190] || (_cache[190] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result19,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => $data.formData.result19 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_71, [_cache[193] || (_cache[193] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine13,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => $data.formData.determine13 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 10 项目编号: A2.2.3.3",
      style: {}
    }), _cache[299] || (_cache[299] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防爬装置在位于地平面上方1000mm±50mm处")])], -1)), _createElementVNode("div", _hoisted_72, [_cache[196] || (_cache[196] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防爬装置离地平面距离")], -1)), _cache[197] || (_cache[197] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_73, [_cache[194] || (_cache[194] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data20,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => $data.formData.data20 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_74, [_cache[195] || (_cache[195] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result20,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => $data.formData.result20 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _cache[300] || (_cache[300] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row",
        "margin-top": "10px"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防爬装置高度至少与扶手带表面齐平，下部与外盖板相交，平行于外盖板方向上的延伸长度不小于1000mm，并且在此长度范围内无踩脚处")])], -1)), _createElementVNode("div", _hoisted_75, [_cache[200] || (_cache[200] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防爬装置延伸长度")], -1)), _cache[201] || (_cache[201] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_76, [_cache[198] || (_cache[198] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data21,
      "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => $data.formData.data21 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_77, [_cache[199] || (_cache[199] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result21,
      "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => $data.formData.result21 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_78, [_cache[202] || (_cache[202] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine14,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => $data.formData.determine14 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 11 项目编号: A2.2.3.4",
      style: {}
    }), _cache[301] || (_cache[301] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "对于与墙相邻并且外盖板的宽度大于125mm的受检设备，或者相邻平行布置并且共用外盖板的宽度大于125mm的自动扶梯或者倾斜的自动人行道，检查在上、下端部装设的阻挡装置是否能够防止人员进入外盖板区域，并且延伸到高度距离扶手带下缘25mm～150mm处")])], -1)), _createElementVNode("div", _hoisted_79, [_cache[205] || (_cache[205] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "外盖板宽度")], -1)), _cache[206] || (_cache[206] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_80, [_cache[203] || (_cache[203] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data22,
      "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => $data.formData.data22 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_81, [_cache[204] || (_cache[204] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result22,
      "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => $data.formData.result22 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_82, [_cache[209] || (_cache[209] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "阻挡装置与扶手带下缘的距离")], -1)), _cache[210] || (_cache[210] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_83, [_cache[207] || (_cache[207] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data23,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => $data.formData.data23 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_84, [_cache[208] || (_cache[208] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result23,
      "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => $data.formData.result23 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_85, [_cache[211] || (_cache[211] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine15,
      "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => $data.formData.determine15 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 12 项目编号: A2.2.3.5",
      style: {}
    }), _cache[302] || (_cache[302] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "自动扶梯或者倾斜的自动人行道和相邻的墙之间装有接近扶手带高度的扶手盖板，并且建筑物(墙)和扶手带中心线之间的距离大于300mm时，或者相邻自动扶梯或者倾斜的自动人行道的扶手带中心线之间的距离大于400mm时，检查在扶手盖板上装设的防滑行装置是否无锐角或者锐边，与扶手带的距离不小于100mm，并且防滑行装置之间的间隔距离不大于1800mm，高度不小于20mm")])], -1)), _createElementVNode("div", _hoisted_86, [_cache[214] || (_cache[214] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "建筑物（墙）和扶手带中心线或者相邻设备扶手带中心线之间的距离")], -1)), _cache[215] || (_cache[215] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_87, [_cache[212] || (_cache[212] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data24,
      "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => $data.formData.data24 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_88, [_cache[213] || (_cache[213] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result24,
      "onUpdate:modelValue": _cache[62] || (_cache[62] = $event => $data.formData.result24 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_89, [_cache[218] || (_cache[218] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防滑行装置与扶手带距离")], -1)), _cache[219] || (_cache[219] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_90, [_cache[216] || (_cache[216] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data25,
      "onUpdate:modelValue": _cache[63] || (_cache[63] = $event => $data.formData.data25 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_91, [_cache[217] || (_cache[217] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result25,
      "onUpdate:modelValue": _cache[64] || (_cache[64] = $event => $data.formData.result25 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_92, [_cache[222] || (_cache[222] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防滑行装置之间的间隔距离")], -1)), _cache[223] || (_cache[223] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_93, [_cache[220] || (_cache[220] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data26,
      "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => $data.formData.data26 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_94, [_cache[221] || (_cache[221] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result26,
      "onUpdate:modelValue": _cache[66] || (_cache[66] = $event => $data.formData.result26 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_95, [_cache[226] || (_cache[226] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防滑行装置的高度")], -1)), _cache[227] || (_cache[227] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_96, [_cache[224] || (_cache[224] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data27,
      "onUpdate:modelValue": _cache[67] || (_cache[67] = $event => $data.formData.data27 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_97, [_cache[225] || (_cache[225] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result27,
      "onUpdate:modelValue": _cache[68] || (_cache[68] = $event => $data.formData.result27 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_98, [_cache[228] || (_cache[228] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine16,
      "onUpdate:modelValue": _cache[69] || (_cache[69] = $event => $data.formData.determine16 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 13 项目编号: A2.2.3.6",
      style: {}
    }), _cache[303] || (_cache[303] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "检查护壁板之间的间隙是否不大于4mm，其边缘是否呈圆角或者倒角状")])], -1)), _createElementVNode("div", _hoisted_99, [_cache[231] || (_cache[231] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "护壁板间隙")], -1)), _cache[232] || (_cache[232] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_100, [_cache[229] || (_cache[229] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data28,
      "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => $data.formData.data28 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_101, [_cache[230] || (_cache[230] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result28,
      "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => $data.formData.result28 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_102, [_cache[233] || (_cache[233] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine17,
      "onUpdate:modelValue": _cache[72] || (_cache[72] = $event => $data.formData.determine17 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 14 项目编号: A2.2.3.7",
      style: {}
    }), _cache[304] || (_cache[304] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "任何一侧的水平间隙不大于4mm，并且两侧对称位置处的间隙总和不大于7mm")])], -1)), _createElementVNode("div", _hoisted_103, [_cache[236] || (_cache[236] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "单侧水平间隙")], -1)), _cache[237] || (_cache[237] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_104, [_cache[234] || (_cache[234] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data29,
      "onUpdate:modelValue": _cache[73] || (_cache[73] = $event => $data.formData.data29 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_105, [_cache[235] || (_cache[235] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result29,
      "onUpdate:modelValue": _cache[74] || (_cache[74] = $event => $data.formData.result29 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_106, [_cache[240] || (_cache[240] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "两侧间隙总和")], -1)), _cache[241] || (_cache[241] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_107, [_cache[238] || (_cache[238] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data30,
      "onUpdate:modelValue": _cache[75] || (_cache[75] = $event => $data.formData.data30 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_108, [_cache[239] || (_cache[239] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result30,
      "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => $data.formData.result30 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_109, [_cache[242] || (_cache[242] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine18,
      "onUpdate:modelValue": _cache[77] || (_cache[77] = $event => $data.formData.determine18 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _cache[305] || (_cache[305] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row",
        "margin-top": "10px"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "围裙板设置在踏板之上时，踏板表面与围裙板下端的垂直间隙不大于4mm，踏板侧边与围裙板垂直投影间不产生间隙")])], -1)), _createElementVNode("div", _hoisted_110, [_cache[245] || (_cache[245] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "踏板表面与围裙板下端的垂直间隙")], -1)), _cache[246] || (_cache[246] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_111, [_cache[243] || (_cache[243] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data31,
      "onUpdate:modelValue": _cache[78] || (_cache[78] = $event => $data.formData.data31 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_112, [_cache[244] || (_cache[244] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result31,
      "onUpdate:modelValue": _cache[79] || (_cache[79] = $event => $data.formData.result31 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_113, [_cache[247] || (_cache[247] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine19,
      "onUpdate:modelValue": _cache[80] || (_cache[80] = $event => $data.formData.determine19 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 15 项目编号: A2.2.3.8",
      style: {}
    }), _cache[306] || (_cache[306] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "围裙板防夹装置端点位于梳齿与踏面相交线前(梯级侧)不小于50mm，但不大于150mm 的位置")])], -1)), _createElementVNode("div", _hoisted_114, [_cache[250] || (_cache[250] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "防夹装置端点位置")], -1)), _cache[251] || (_cache[251] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_115, [_cache[248] || (_cache[248] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data32,
      "onUpdate:modelValue": _cache[81] || (_cache[81] = $event => $data.formData.data32 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_116, [_cache[249] || (_cache[249] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result32,
      "onUpdate:modelValue": _cache[82] || (_cache[82] = $event => $data.formData.result32 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_117, [_cache[252] || (_cache[252] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine20,
      "onUpdate:modelValue": _cache[83] || (_cache[83] = $event => $data.formData.determine20 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 16 项目编号: A2.2.4.1",
      style: {}
    }), _cache[307] || (_cache[307] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "在工作区段内的任何位置，从踏面测得的两个相邻梯级或者踏板之间的间隙不大于6mm；在自动人行道过渡曲线区段，如果踏板的前缘和相邻踏板的后缘啮合，其间隙允许增至8mm")])], -1)), _createElementVNode("div", _hoisted_118, [_cache[255] || (_cache[255] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "相邻梯级或者踏板间隙")], -1)), _cache[256] || (_cache[256] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_119, [_cache[253] || (_cache[253] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data33,
      "onUpdate:modelValue": _cache[84] || (_cache[84] = $event => $data.formData.data33 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_120, [_cache[254] || (_cache[254] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result33,
      "onUpdate:modelValue": _cache[85] || (_cache[85] = $event => $data.formData.result33 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_121, [_cache[257] || (_cache[257] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine21,
      "onUpdate:modelValue": _cache[86] || (_cache[86] = $event => $data.formData.determine21 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 17 项目编号: A2.3.1",
      style: {}
    }), _cache[308] || (_cache[308] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测内容与要求: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "对于由使用者的进入而自动启动的受检设备，观察、测量当使用者从预定运行方向进入时，是否经过足够的时间(至少为预期输送时间再加上10s)才能自动停止运行；当使用者从预定运行方向相反的方向进入时，是否仍按照预先确定的方向启动，运行时间不少于10s")])], -1)), _createElementVNode("div", _hoisted_122, [_cache[260] || (_cache[260] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "自动停止运行时间")], -1)), _cache[261] || (_cache[261] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "s")], -1)), _createElementVNode("div", _hoisted_123, [_cache[258] || (_cache[258] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data34,
      "onUpdate:modelValue": _cache[87] || (_cache[87] = $event => $data.formData.data34 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_124, [_cache[259] || (_cache[259] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result34,
      "onUpdate:modelValue": _cache[88] || (_cache[88] = $event => $data.formData.result34 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_125, [_cache[264] || (_cache[264] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "自动启动运行时间")], -1)), _cache[265] || (_cache[265] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "s")], -1)), _createElementVNode("div", _hoisted_126, [_cache[262] || (_cache[262] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data35,
      "onUpdate:modelValue": _cache[89] || (_cache[89] = $event => $data.formData.data35 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_127, [_cache[263] || (_cache[263] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result35,
      "onUpdate:modelValue": _cache[90] || (_cache[90] = $event => $data.formData.result35 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_128, [_cache[266] || (_cache[266] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine22,
      "onUpdate:modelValue": _cache[91] || (_cache[91] = $event => $data.formData.determine22 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_el_descriptions, {
      title: "序号: 18 项目编号: A2.3.3",
      style: {}
    }), _cache[309] || (_cache[309] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (1)  检测内容与要求:"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("   "), _createElementVNode("img", {
      src: _imports_0,
      style: {
        "width": "60%",
        "height": "100%"
      }
    })])], -1)), _createElementVNode("div", _hoisted_129, [_cache[269] || (_cache[269] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "空载上行制停距离")], -1)), _cache[270] || (_cache[270] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "m")], -1)), _createElementVNode("div", _hoisted_130, [_cache[267] || (_cache[267] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data36,
      "onUpdate:modelValue": _cache[92] || (_cache[92] = $event => $data.formData.data36 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_131, [_cache[268] || (_cache[268] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result36,
      "onUpdate:modelValue": _cache[93] || (_cache[93] = $event => $data.formData.result36 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_132, [_cache[273] || (_cache[273] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "空载下行制停距离")], -1)), _cache[274] || (_cache[274] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "m")], -1)), _createElementVNode("div", _hoisted_133, [_cache[271] || (_cache[271] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data37,
      "onUpdate:modelValue": _cache[94] || (_cache[94] = $event => $data.formData.data37 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_134, [_cache[272] || (_cache[272] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result37,
      "onUpdate:modelValue": _cache[95] || (_cache[95] = $event => $data.formData.result37 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_135, [_cache[275] || (_cache[275] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine23,
      "onUpdate:modelValue": _cache[96] || (_cache[96] = $event => $data.formData.determine23 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])]), _cache[310] || (_cache[310] = _createElementVNode("div", {
      style: {
        "display": "flex",
        "flex-direction": "row",
        "margin-top": "10px"
      }
    }, [_createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, "  (2)  检测内容与要求:"), _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("   "), _createElementVNode("img", {
      src: _imports_1,
      style: {
        "width": "60%",
        "height": "100%"
      }
    })])], -1)), _createElementVNode("div", _hoisted_136, [_cache[278] || (_cache[278] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "空载上行制停距离")], -1)), _cache[279] || (_cache[279] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_137, [_cache[276] || (_cache[276] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data38,
      "onUpdate:modelValue": _cache[97] || (_cache[97] = $event => $data.formData.data38 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_138, [_cache[277] || (_cache[277] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result38,
      "onUpdate:modelValue": _cache[98] || (_cache[98] = $event => $data.formData.result38 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_139, [_cache[282] || (_cache[282] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  检测项目: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "空载下行制停距离")], -1)), _cache[283] || (_cache[283] = _createElementVNode("div", {
      style: {
        "font-weight": "bold"
      }
    }, [_createTextVNode("  单位: "), _createElementVNode("text", {
      style: {
        "font-weight": "100"
      }
    }, "mm")], -1)), _createElementVNode("div", _hoisted_140, [_cache[280] || (_cache[280] = _createTextVNode("  观测数据: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.data39,
      "onUpdate:modelValue": _cache[99] || (_cache[99] = $event => $data.formData.data39 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_141, [_cache[281] || (_cache[281] = _createTextVNode("  测量结果: ", -1)), _createVNode(_component_el_input, {
      style: {
        "font-weight": "100",
        "width": "200px"
      },
      modelValue: $data.formData.result39,
      "onUpdate:modelValue": _cache[100] || (_cache[100] = $event => $data.formData.result39 = $event),
      placeholder: "请输入"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_142, [_cache[284] || (_cache[284] = _createTextVNode("  结果判定: ", -1)), _createVNode(_component_el_radio_group, {
      modelValue: $data.formData.determine24,
      "onUpdate:modelValue": _cache[101] || (_cache[101] = $event => $data.formData.determine24 = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        label: "√"
      }), _createVNode(_component_el_radio, {
        label: "×"
      }), _createVNode(_component_el_radio, {
        label: "/"
      })]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_143, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: _cache[102] || (_cache[102] = $event => $options.back())
  }, {
    default: _withCtx(() => [...(_cache[312] || (_cache[312] = [_createTextVNode(" 返回", -1)]))]),
    _: 1
  }), _createVNode(_component_el_button, {
    type: "primary",
    onClick: _cache[103] || (_cache[103] = $event => $options.save())
  }, {
    default: _withCtx(() => [...(_cache[313] || (_cache[313] = [_createTextVNode(" 保存", -1)]))]),
    _: 1
  })])], 64);
}